var _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMembers = function SvgMembers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D0DCD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5354 32.812H38.6793C38.8685 33.33 38.9719 33.889 38.9719 34.4716V41.4864C38.9719 41.7293 38.9296 41.9625 38.8527 42.1793H41.9211C43.0674 42.1793 43.9998 41.2468 43.9998 40.1006V36.2765C43.9999 34.3662 42.4457 32.812 40.5354 32.812Z",
    fill: "#455E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0281 34.4716C25.0281 33.8889 25.1314 33.33 25.3206 32.812H23.4645C21.5542 32.812 20 34.3662 20 36.2765V40.1007C20 41.2469 20.9325 42.1794 22.0787 42.1794H25.1473C25.0703 41.9624 25.0281 41.7293 25.0281 41.4864V34.4716Z",
    fill: "#455E4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1224 31.0068H29.8792C27.9689 31.0068 26.4147 32.561 26.4147 34.4714V41.4862C26.4147 41.8689 26.7249 42.1791 27.1076 42.1791H36.8941C37.2767 42.1791 37.587 41.8689 37.587 41.4862V34.4714C37.587 32.561 36.0328 31.0068 34.1224 31.0068Z",
    fill: "#455E4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 21.8208C29.7033 21.8208 27.8342 23.6899 27.8342 25.9874C27.8342 27.5457 28.6943 28.9068 29.9646 29.6213C30.567 29.9602 31.2616 30.1539 32.0008 30.1539C32.7399 30.1539 33.4345 29.9602 34.037 29.6213C35.3072 28.9068 36.1673 27.5457 36.1673 25.9874C36.1673 23.6899 34.2982 21.8208 32.0008 21.8208Z",
    fill: "#455E4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6833 25.7041C22.9651 25.7041 21.5673 27.1019 21.5673 28.8201C21.5673 30.5383 22.9651 31.9361 24.6833 31.9361C25.1191 31.9361 25.5342 31.8459 25.9112 31.6836C26.563 31.4029 27.1005 30.9062 27.4331 30.2839C27.6665 29.8472 27.7993 29.3489 27.7993 28.8201C27.7993 27.102 26.4015 25.7041 24.6833 25.7041Z",
    fill: "#455E4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.316 25.7041C37.5978 25.7041 36.2 27.1019 36.2 28.8201C36.2 29.349 36.3327 29.8472 36.5662 30.2839C36.8988 30.9062 37.4362 31.403 38.0881 31.6836C38.4651 31.8459 38.8801 31.9361 39.316 31.9361C41.0342 31.9361 42.432 30.5383 42.432 28.8201C42.432 27.1019 41.0342 25.7041 39.316 25.7041Z",
    fill: "#455E4D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMembers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/members.d60bb2c6.svg";
export { ForwardRef as ReactComponent };